import {
  Box, Button, Grid, Typography, makeStyles,
} from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../contexts/StoryContext';
import MessageBox from './MessageBox';
import SubquestionBox from './SubquestionBox';

function Resources() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <Box displayPrint="none">
      <SubquestionBox color={lightColor}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >

          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Resources
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  {/* <Typography variant="h5" gutterBottom>Placeholder: Resources</Typography> */}
                  <Typography variant="body1" gutterBottom>
                    Now that you&apos;ve seen the data, dig deeper by clicking below to see additional resources on this topic, and support in sharing the information more broadly.
                    On the resource page, you can also access notes on the methodology, definitions, and much more.
                  </Typography>

                  <Button color="primary" variant="contained" href="/our-issues/research/ccdc/advocacy-resources/">Resources</Button>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SubquestionBox>
    </Box>
  );
}

export default Resources;
